import React, { forwardRef } from "react";
import { BSDiv } from "../../types";

export const ModalContent = forwardRef<HTMLDivElement, BSDiv>(
  ({ className = "", children, ...props }, ref) => (
    <div {...props} className={`modal-content ${className}`} ref={ref}>
      {children}
    </div>
  )
);